import { render, staticRenderFns } from "./CampaignTabItems.vue?vue&type=template&id=6274eeab&scoped=true&"
import script from "./CampaignTabItems.vue?vue&type=script&lang=js&"
export * from "./CampaignTabItems.vue?vue&type=script&lang=js&"
import style0 from "./CampaignTabItems.vue?vue&type=style&index=0&id=6274eeab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6274eeab",
  null
  
)

export default component.exports